import { Component, OnInit } from '@angular/core';
import {PatientAlertProvider} from '../../../../providers/patient-alert/patient-alert';
import {PatientDataProvider} from '../../../../providers/patient-data/patient-data';
import {HistoryProvider} from '../../../../providers/history/history';
import {OpenCaseProvider} from '../../../../providers/open-case/open-case';
import {Logger} from 'ionic-logging-service';
import {AlertData} from '../../../../interfaces/alert-data';
import {PatientData} from '../../../../interfaces/patient-data';
import {Events} from '../../../../providers/events';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the QuitComponent component.
 */
@Component({
  selector: 'quit',
  templateUrl: 'quit.html',
  styleUrls: ['./quit.scss']
})
export class QuitComponent implements OnInit {

  formdata: any = {
    reason: '',
    comment: ''
  };


  private logger: Logger;
  reasons: { key: string; value: string; }[] = [];

  constructor(public patientAlertProvider: PatientAlertProvider, 
    private historyProvider: HistoryProvider, private openCaseProvider: OpenCaseProvider, 
    private patientDataProvider: PatientDataProvider, private events: Events, private translate:TranslateService) {

    this.translate.onLangChange.subscribe(() => {
      this.ngOnInit();
    })

  }

  private getLogger() {
    if(this.logger) {
      return this.logger;
    }

    return this.logger = this.patientAlertProvider.api.getLogger('Hausnotruf.Quit');
  }

  async ngOnInit() {

    let translateData = await firstValueFrom(this.translate.get([
      'Reasons.FalseAlarm','Reasons.AlertPerson', 'Reasons.AlertProvider', 'Reasons.AlertNursing', 'Reasons.AlertDoctor', 'Reasons.AlertKTW', 'Reasons.AlertRD', 'Reasons.SocialCall', 'Reasons.UnclearReputation', 'Reasons.RepeatedCall', 'Reasons.ServiceRequested', 'Reasons.Commissioning','Reasons.DeviceTest'
    ]));

    translateData = Object.values(translateData);

    this.reasons = [
      {
        key: translateData[0],
        value: translateData[0]
      },
      {
        key: translateData[1],
        value: translateData[1]
      },
      {
        key: translateData[2],
        value: translateData[2]
      },
      {
        key: translateData[3],
        value: translateData[3]
      },
      {
        key: translateData[4],
        value: translateData[4]
      },
      {
        key: translateData[5],
        value: translateData[5]
      },
      {
        key: translateData[6],
        value: translateData[6]
      },
      {
        key: translateData[7],
        value: translateData[7]
      },
      {
        key: translateData[8],
        value: translateData[8]
      },
      {
        key: translateData[9],
        value: translateData[9]
      },
      {
        key: translateData[10],
        value: translateData[10]
      },
      {
        key: translateData[11],
        value: translateData[11]
      },
      {
        key: translateData[12],
        value: translateData[12]
      },
    ];
  }

  quit(form) {
    if (form.valid) {
      this.patientAlertProvider.quit(this.formdata).then(() => {
        const quitData = {
          dateTime: new Date().getTime(),
          code: '8888',
          desc: this.formdata.reason + ' ' + this.formdata.comment,
          editorPerson: this.patientAlertProvider.api._user.profile.firstname + ' ' + this.patientAlertProvider.api._user.profile.lastname
        };

        this.historyProvider.setHistoryData(quitData);

        this.openCaseProvider.tableData.getAll().then((data) => {
          this.openCaseProvider.tableData.remove(data.filter((elem: any) => elem._id === this.patientAlertProvider.activeAlertData._id)[0]);

          this.getLogger().info('alert Quit', quitData);

          // this.patientAlertProvider.activeAlertData = resp.data.data.data;
          this.patientDataProvider.activePatientData = new PatientData();
          this.patientAlertProvider.activeAlertData = new AlertData();
          this.formdata = {
            reason: '',
            comment: ''
          };
          this.events.publish('closePatientModal');
          this.events.publish('changeTabData');
        });

      });
    }
  }

}
